import Propertydetails from '../components/proterty-detail/index';
import Layout from '../components/layouts/allpagelayout';
export default function PropertyDetailPage() {
  return (
    <Layout>
      <Propertydetails />
    </Layout>
  );
}